import { render, staticRenderFns } from "./NsTopnavLinkList.vue?vue&type=template&id=561004d2&scoped=true&"
import script from "./NsTopnavLinkList.vue?vue&type=script&lang=js&"
export * from "./NsTopnavLinkList.vue?vue&type=script&lang=js&"
import style0 from "./NsTopnavLinkList.vue?vue&type=style&index=0&id=561004d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561004d2",
  null
  
)

export default component.exports